import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ModuleTypeForm from '../../../components/forms/ModuleTypeForm';
import { useModuleTypeApi } from '../../../hooks/useModuleTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { ModuleTypeDTO } from '../../../services/apiClient';

const ModuleTypeEdit: React.FC = () => {
  const { getById, edit } = useModuleTypeApi();
  const [entityData, setEntityData] = useState<ModuleTypeDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Module Types', href: '/admin/moduletypes' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching ModuleType data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/moduletypes');
    } catch (error) {
      console.error('Error updating ModuleType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/moduletypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ModuleType.Edit"
    >
      {entityData ? (
        <ModuleTypeForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/moduletypes')}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default ModuleTypeEdit;
